import { FaqSection } from '../models/faq/faq.model';

export const PUBLIC_FAQ_LIST: FaqSection[] = [
  {
    id: 'what-is-cube',
    name: 'What is Cube?',
    faqs: [
      {
        question: '',
        answer:
          'Cube is a market research and insights provider for e-commerce. We provide reliable and granular data for all popular e-commerce platforms in the region, as well as consumer and competitor insights.',
      },
    ],
  },
  {
    id: 'what-is-metercube',
    name: 'What is MeterCube?',
    faqs: [
      {
        question: '',
        answer:
          'MeterCube is an online platform for our subscribers that gives them access to e-commerce data through an easy to use web-platform. It was launched in November 2023, and is currently available in beta version.',
      },
    ],
  },
  {
    id: 'data-available',
    name: 'What data and insights are available?',
    faqs: [
      {
        question: '',
        answer:
          'For markets and e-commerce channels, you can track the total GMV, NMV, # of users, spending per user, and cuts across categories, sub-channels (e.g. Mall vs. marketplace), and local geographies (e.g. Jakarta vs. Java vs. Rest of Indonesia). For select competitors, you can track their sales, product assortment and pricing. For TikTok Shop, we also offer content insights across short-form videos and livestreaming.',
      },
    ],
  },
  {
    id: 'custom-insight',
    name: 'Do you offer custom data or insights?',
    faqs: [
      {
        question: '',
        answer:
          'Yes, we do. If you have a question on eCommerce, we have the answer!',
      },
    ],
  },
  {
    id: 'how-to-get-data',
    name: 'How do you get your data?',
    faqs: [
      {
        question: '',
        answer:
          'Cube collects and triangulates data across multiple sources, including data from partners as well as data collected on its own. Then, we use AI and proprietary modeling tools to "fill in" the gaps, statistically estimate "best-fit" data points that are unavailable otherwise, and enrich and tag this data to unlock actionable insights for our clients.',
      },
    ],
  },
];
